import styled from "styled-components";
import { Box } from "@sqymagma/elements";

export const Content = styled(Box)`
  border-radius: ${(p) => p.theme.radii.s};
  background: ${(p) => p.theme.colors.septenaryBackground};
`;
